import React from "react";
import I18n from "../../../i18n/";
import { CounselingGeneric } from "./index";
import ReportAction from "../../../actions/ReportAction";
import { CounselingSupportGraph } from "../../../constants/supportGraph";
import { TargetValueType } from "../CompareValuePanel";
import ReportUtil from "../../../util/report";

export default (props)=>(
	<CounselingGeneric 
		typeKey={CounselingSupportGraph.Gender}
		subHeader={I18n.t("gender")}
		fetchMain={ReportAction.fetchCounGender}
		getAutoSelectItem={ReportUtil.pickAvailableNumberValueKey}
	/>
);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Counseling/CounselingGender.js